<script>
export default {
    data() {
        return {
            countrySet: (this.$cookie.get('site-set')) ? true : false
        }
    },
    mounted() {
        if (this.$cookie.get('site') === 'ru' || this.$cookie.get('site') === 'cs' || this.$cookie.get('site') === 'es')
        {
            this.$cookie.delete('site');
            this.$cookie.delete('site-set');
        }
    },
    props: {
        showCloseButton: {
            type: Boolean,
            required: true
        }
    },
    computed: {},
    methods: {
        setSite(site, redirect) {
            this.$cookie.set('site', site, 3650)
            this.$cookie.set('site-set', true, 3650)
            window.location = redirect
        },
        goToUrl(url) {
            window.location = url
        },
        closeLanguageSelector() {
            this.$emit('close-language-selector');
        },
        setComponentFocus(el) {
            this.$nextTick().then(() => this.setFocus(el));
        },
        setFocus(el) {
            switch (el)
            {
                case 'close':
                    this.$refs.reflsclose.focus();
                    break;
                case 'body':
                    this.$refs.reflsbody.focus();
                    break;
            }
        }
    }
}
</script>
